import React from 'react';
import { Grid, Typography } from '@mui/material';
import SectionGrid from '@shared/components/SectionGrid';

const PlateFormSection = ({
  title,
  children,
  content,
  xs = 12,
  md = 3,
  sectionGridProps = {},
  direction = 'column',
}) => {
  const TitleComponent = ({ children }) => (
    <Typography
      sx={{
        fontSize: 20,
        fontWeight: 600,
        color: '#000',
        mb: '10px',
      }}
    >
      {children}
    </Typography>
  );

  return (
    <Grid item container direction={direction} xs={xs} md={md} sx={{ pt: 1 }}>
      <Grid item>
        <TitleComponent>{title}</TitleComponent>
      </Grid>

      {content ? (
        <Grid item xs={12}>
          {content}
        </Grid>
      ) : (
        <SectionGrid padding="0px" {...sectionGridProps}>
          {children}
        </SectionGrid>
      )}
    </Grid>
  );
};

export default PlateFormSection;
